import React from "react";

// reactstrap components
import { Container, Group, SimpleGrid, Skeleton, Stack, Title } from "@mantine/core";
import { IndividualCertCard, IndividualCertData } from "@/views/pages/professional-cert/ListingPage";
import { useQuery } from "@tanstack/react-query";
import authApi from "@/services/auth-api";

function CompletedCourseSection({
	isReady = true
}) {
	const query = useQuery({
		queryKey: ["certification"],
		queryFn: () => {
			return authApi.getProfileBundleV2() as Promise<{
				individual_certs: IndividualCertData[]
				individual_cert_preview?: string
			}>
		}
	})


	if (!isReady) {
		return null
	}

	return (
		<div>
			<Container py={50}>
				{
					query.isLoading && !query.isFetched
						? (<div className="d-flex flex-grow justify-content-center align-items-center">
							<Skeleton height={30} width={300} />
						</div>)
						: query.data?.individual_certs?.length > 0
							? <Title order={3} ta={"center"}>
								Completed Courses {query.data?.individual_certs?.length ? `(${query.data?.individual_certs?.length})` : ''}
							</Title>
							: null
				}

				<SimpleGrid
					mt={50}
					cols={{
						base: 1,
						md: 3,
					}}>
					{
						query.data?.individual_certs?.map((cert, index) => (
							<IndividualCertCard
								key={cert.cert_id} cert={cert}
								cert_image_url={cert.cert_image_url}
								delay={index % 3 * 0.2}
							/>
						))
					}
				</SimpleGrid>

				{
					(query.isFetching && !query.isFetched || !isReady) && (
						<SimpleGrid cols={3}>
							{Array.from({ length: 3 }).map((_, index) => (
								<Stack gap={10}>
									<Skeleton key={index} height={200} w={"100%"} style={{ borderRadius: 20 }} />
									<Skeleton key={index} height={15} w={"100%"} style={{ borderRadius: 20 }} />
									<Skeleton key={index} height={15} w={"50%"} style={{ borderRadius: 20 }} />
									<Group justify="end">
										<Skeleton key={index} height={30} w={"30%"} style={{ borderRadius: 50 }} />
									</Group>
								</Stack>
							))}
						</SimpleGrid>
					)
				}
			</Container>
		</div>
	);
}

export default CompletedCourseSection;
